export default __webpack_public_path__ + "static/media/foto_contacto_enmascarada.b47dc84a.jpg";